import React from "react"
import { withRouter } from "react-router-dom"

import {
  Container,
  Image,
  Segment,
  Header,
  Button,
  Grid,
  Message
} from "semantic-ui-react"

const Welcome = (props) => {
  const { isAuthenticated, isAuthorized, loading } = props
  const isAuth = () => isAuthenticated && isAuthorized
  const title = isAuth() ? "Αίτηση" : "Σύνδεση"
  const handleClick = () => {
    if (isAuth()) {
      if (props.isFinal === false && props.working === true) {
        props.history.push("/application")
      } else {
        props.history.push("/report")
      }
    } else {
      props.login()
    }
  }

  return (
    <Container style={{ marginTop: "2em", marginBottom: "2em" }}>
      <Image centered src="/badge2.png" />
      <Segment style={{ border: "0", boxShadow: "none" }}>
        <Header textAlign="center" as="h1">
          Πολεμική Αεροπορία
        </Header>
        <Header textAlign="center" as="h2" style={{ fontWeight: "100" }}>
          Σχεδιασμός Επιθυμιών Μεταθέσεων Προσωπικού Έτους{" "}
          {process.env.REACT_APP_YEAR}
        </Header>
        {/* <Header textAlign="center" as="h2">
          Συμπληρωματική Προκήρυξη Θέσεων Εξωτερικού 2019
        </Header> */}
      </Segment>
      <Message
        style={{ textAlign: "center" }}
        content="Η Πολεμική Αεροπορία παρέχει στο προσωπικό της τη δυνατότητα
        ηλεκτρονικής υποβολής επιθυμίας μετάθεσης."
      />
      <Message
        style={{
          textAlign: "center",
          width: "100%",
          backgroundColor: "#fff3cd",
          color: "#664d03"
        }}
        content="Για την απρόσκοπτη χρήση της υπηρεσίας προτείνεται όπως εκτελέσετε εκκαθάριση της προσωρινής μνήμης και των αποθηκευμένων cookies στο πρόγραμμα περιήγησής σας."
      />
      {/* <p>
        Όποιος δεν γνωρίζει τα διαπιστευτήριά του, μπορεί να τα ανακτήσει από
        την εφαρμογή ενημέρωσης για τη μισθοδοσία . Για είσοδο στην εφαρμογή,
        απαιτείται να γνωρίζει τον ΑΦΜ, τον ΑΜΚΑ και τον Αριθμό Μητρώου του. Τα
        στοιχεία εμφανίζονται με την επιλογή «Υπηρεσιακό Email», κάτω αριστερά.
        Το συνθηματικό που εμφανίζεται είναι το αρχικό. Αν κάποιος το έχει
        αλλάξει, η εφαρμογή δεν έχει ενημερωθεί.
      </p>
      <p>
        Αν κάποιος έχει αλλάξει το συνθηματικό του και δεν το θυμάται, οι
        επιλογές που έχει είναι οι εξής:
      </p>
      <ul>
        <li>
          Να ζητήσει αυτοπροσώπως επαναφορά του συνθηματικού, με φυσική παρουσία
          στο Γραφείο Δικτύων του ΚΜΗ/ΓΕΑ. Απαιτείται να προσκομίσει μέσο
          εξακρίβωσης της ταυτοπροσωπίας (δελτίο ταυτότητας, δίπλωμα οδήγησης,
          διαβατήριο, ατομικό δελτίο εισόδου) με πρόσφατη φωτογραφία.
        </li>
        <li>
          Να υποβάλει αίτημα επαναφοράς του συνθηματικού από τον ατομικό
          λογαριασμό του MIS e-mail στο Γραφείο Δικτύων του ΚΜΗ/ΓΕΑ
          (GEA-KMH-DIKTYA@haf.gr). Αν δεν διαθέτει ατομικό λογαριασμό, το αίτημα
          θα υποβάλλεται μέσω του οικείου φορέα Πληροφορικής που τον
          υποστηρίζει.
        </li>
        <li>
          Να υποβάλει ατομική αναφορά, με την οποία θα ζητά την επαναφορά του
          κωδικού. Η απάντηση με το νέο κωδικό, θα του αποστέλλεται μόνο
          ταχυδρομικά, σε κλειστό φάκελο.
        </li>
      </ul> */}
      <br />
      <Grid centered columns={1}>
        <Button
          loading={loading}
          primary
          style={{ padding: "10px 60px" }}
          onClick={handleClick}>
          {title}
        </Button>
      </Grid>
    </Container>
  )
}

export default withRouter(Welcome)
